import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';
import ZebraTagModel from './../../../models/ZebraTagModel';

export default async function createTag(tag = ZebraTagModel()) {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/zebraTagCode/createZebraTagCode`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        description: tag.description,
        zebraCode: tag.zebraCode
      }
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return ZebraTagModel(_ret.data.data);
  } catch (error) {
    console.log('Error createTag', error);
    throw error;
  }
}
